// config.js
const config = {
    labelStyle: {
        border: 'none',
        boxShadow: 'none',
        fontSize: "18px",
        color: "black",
        paddingLeft: '8px',
        backgroundColor: 'transparent',
        cursor: 'pointer',  // Optional: Change cursor to indicate it's editable
    },
    stepsObject: { step1: "प्राथमिक माहिती", step2: "उत्पन्न आणि माध्यम", step3: "कुटुंबाची माहिती" },
    formData: {
        step1: [
            {
                label: "name",
                labelTitle: "नाव",
                value: "",
                type: "input",
                dataType: "text",
                display: true,
                placeholder: "नावासमोर कुमार / कुमारी अथवा अन्य शीर्षक भरू शकता ........   (उदा: कु. सदाशिव रामराव पवार )",
                priority: 1,
                mandatory: true
            },
            {
                label: "birthDate",
                labelTitle: "जन्मतारीख",
                value: "",
                type: "input",
                dataType: "date",
                display: true,
                placeholder: "जन्म तारीख",
                priority: 2,
                mandatory: true
            },
            {
                label: "birthTime",
                labelTitle: "जन्म वेळ",
                value: "",
                type: "input",
                dataType: "time",
                display: true,
                placeholder: "जन्म वेळ",
                priority: 3,
                mandatory: false
            },
            {
                label: "birthPlace",
                labelTitle: "जन्म स्थळ",
                value: "",
                type: "input",
                dataType: "text",
                display: false,
                placeholder: "जन्म स्थळ",
                priority: 4,
                mandatory: false
            },
            {
                label: "birthName",
                labelTitle: "जन्म नाव",
                value: "",
                type: "input",
                dataType: "text",
                display: false,
                placeholder: "जन्म नाव",
                priority: 5,
                mandatory: false
            },
            {
                label: "castReligion",
                labelTitle: "धर्म-जात",
                value: "",
                type: "input",
                dataType: "text",
                display: true,
                placeholder: "धर्म-जात",
                priority: 6,
                mandatory: true
            },
            {
                label: "familyGod",
                labelTitle: "कुलदैवत",
                value: "",
                type: "input",
                dataType: "text",
                display: false,
                placeholder: "कुलदैवत",
                priority: 7,
                mandatory: false
            },
            {
                label: "gotr",
                labelTitle: "गोत्र",
                value: "",
                type: "input",
                dataType: "text",
                display: false,
                placeholder: "गोत्र",
                priority: 8,
                mandatory: false
            },
            {
                label: "devak",
                labelTitle: "देवक",
                value: "",
                type: "input",
                dataType: "text",
                display: false,
                placeholder: "देवक",
                priority: 9,
                mandatory: false
            },
            {
                label: "nakshytra",
                labelTitle: "नक्षत्र",
                value: "",
                type: "input",
                dataType: "text",
                display: false,
                placeholder: "नक्षत्र",
                priority: 10,
                mandatory: false
            },
            {
                label: "rashi",
                labelTitle: "राशी",
                value: "",
                type: "dropdown",
                dataType: "text",
                display: false,
                placeholder: "राशी",
                priority: 11,
                mandatory: false
            },
            {
                label: "gan",
                labelTitle: "गण",
                value: "",
                type: "dropdown",
                dataType: "text",
                display: false,
                placeholder: "गण",
                priority: 12,
                mandatory: false
            },
            {
                label: "nadi",
                labelTitle: "नाडी",
                value: "",
                type: "dropdown",
                dataType: "text",
                display: false,
                placeholder: "नाडी",
                priority: 13,
                mandatory: false
            },
            {
                label: "height",
                labelTitle: "ऊंची",
                value: "",
                type: "dropdown",
                dataType: "text",
                display: true,
                placeholder: "ऊंची",
                priority: 14,
                mandatory: false
            },
            {
                label: "color",
                labelTitle: "वर्ण",
                value: "",
                type: "dropdown",
                dataType: "text",
                display: true,
                placeholder: "वर्ण",
                priority: 15,
                mandatory: false
            },
            {
                label: "bloodgroup",
                labelTitle: "रक्तगट",
                value: "",
                type: "dropdown",
                dataType: "text",
                display: true,
                placeholder: "रक्तगट",
                priority: 16,
                mandatory: false
            },
            {
                label: "aboutme",
                labelTitle: "ओळख",
                value: "",
                type: "textarea",
                dataType: "text",
                display: true,
                placeholder: "या जागेवर आपल्याला आपल्या बद्दल संक्षेपित माहिती भरण्याची आवश्यकता आहे. या जागेवर आपल्याला आपल्या व्यक्तिमत्वाच्या गुणांची ओळख पटवून देण्यात मदत होईल.",
                priority: 17,
                mandatory: false
            },
        ],
        step2: [
            {
                label: "job",
                labelTitle: "नोकरी/व्यवसाय",
                value: "",
                type: "input",
                dataType: "text",
                display: true,
                placeholder: "नोकरी/व्यवसाय", 
                priority: 1,
                mandatory: false
            },
            {
                label: "education",
                labelTitle: "शिक्षण",
                value: "",
                type: "input",
                dataType: "text",
                display: true, 
                placeholder: "पदवी किंवा उच्च पदवीचा उल्लेख करावा",
                priority: 2,
                mandatory: true
            },
            {
                label: "income",
                labelTitle: "वेतन/उत्पन्न",
                value: "",
                type: "input",
                dataType: "text",
                display: true, 
                placeholder: "वेतन/उत्पन्न",
                priority: 3,
                mandatory: false
            },
            {
                label: "address",
                labelTitle: "पत्ता",
                value: "",
                type: "input",
                dataType: "text",
                display: true, 
                placeholder: "मूळ पत्ता किंवा रहिवाशी पत्ता नोंदवा.",
                priority: 4,
                mandatory: true
            },
            {
                label: "mobileNumber",
                labelTitle: "मोबाइल नं.",
                value: "",
                type: "input",
                dataType: "text",
                display: true, 
                placeholder: "मोबाइल नं.",
                priority: 5,
                mandatory: true
            },
        ],
        step3: [
            {
                label: "fatherName",
                labelTitle: "वडिलांचे नाव",
                value: "",
                type: "input",
                dataType: "text",
                display: true, 
                placeholder: "वडिलांचे नाव व व्यवसाय नमूद करणे अपेक्षित आहे",
                priority: 1,
                mandatory: true
            },
            {
                label: "motherName",
                labelTitle: "आईचे नाव",
                value: "",
                type: "input",
                dataType: "text",
                display: true, placeholder: "आईचे नाव",
                priority: 2,
                mandatory: true
            },
            {
                label: "brother1",
                labelTitle: "भाऊ",
                value: "",
                type: "input",
                dataType: "text",
                display: true, 
                placeholder: "एकापेक्षा अधिक भावाचे नाव असतील तर वरती पर्याय आहे",
                priority: 3,
                mandatory: false
            },
            {
                label: "brother2",
                labelTitle: "मोठा भाऊ",
                value: "",
                type: "input",
                dataType: "text",
                display: false, 
                placeholder: "एकापेक्षा अधिक भावाचे नाव असतील तर वरती पर्याय आहे",
                priority: 4,
                mandatory: false
            },
            {
                label: "brother3",
                labelTitle: "छोटा भाऊ",
                value: "",
                type: "input",
                dataType: "text",
                display: false, 
                placeholder: "एकापेक्षा अधिक भावाचे नाव असतील तर वरती पर्याय आहे",
                priority: 5,
                mandatory: false
            },
            {
                label: "sister1",
                labelTitle: "बहीण",
                value: "",
                type: "input",
                dataType: "text",
                display: true, 
                placeholder: "एकापेक्षा अधिक बाहिनेचे नाव असतील तर वरती पर्याय आहे ",
                priority: 6,
                mandatory: false
            },
            {
                label: "sister2",
                labelTitle: "मोठी बहीण",
                value: "",
                type: "input",
                dataType: "text",
                display: false, 
                placeholder: "एकापेक्षा अधिक बाहिनेचे नाव असतील तर वरती पर्याय आहे ",
                priority: 7,
                mandatory: false
            },
            {
                label: "sister3",
                labelTitle: "छोटी बहीण",
                value: "",
                type: "input",
                dataType: "text",
                display: false, 
                placeholder: "एकापेक्षा अधिक बाहिनेचे नाव असतील तर वरती पर्याय आहे ",
                priority: 8,
                mandatory: false
            },
            {
                label: "paternalUncle1",
                labelTitle: "काका",
                value: "",
                type: "input",
                dataType: "text",
                display: true, 
                placeholder: "एकापेक्षा अधिक काकाचे नाव असतील तर वरती पर्याय आहे.",
                priority: 9,
                mandatory: false
            },
            {
                label: "paternalUncle2",
                labelTitle: "काका",
                value: "",
                type: "input",
                dataType: "text",
                display: false, 
                placeholder: "एकापेक्षा अधिक काकाचे नाव असतील तर वरती पर्याय आहे.",
                priority: 10,
                mandatory: false
            },
            {
                label: "maternalUncle1",
                labelTitle: "मामा",
                value: "",
                type: "input",
                dataType: "text",
                display: true, 
                placeholder: "एकापेक्षा अधिक मामाचे नाव असतील तर वरती पर्याय आहे.",
                priority: 11,
                mandatory: false
            },
            {
                label: "maternalUncle2",
                labelTitle: "मामा",
                value: "",
                type: "input",
                dataType: "text",
                display: false,
                placeholder: "एकापेक्षा अधिक मामाचे नाव असतील तर वरती पर्याय आहे.",
                priority: 12,
                mandatory: false
            },
            {
                label: "grandfather1",
                labelTitle: "आजोबा",
                value: "",
                type: "input",
                dataType: "text",
                display: true, 
                placeholder: "एकापेक्षा अधिक आजोबा नाव असतील तर वरती पर्याय आहे.",
                priority: 13,
                mandatory: false
            },
            {
                label: "grandfather2",
                labelTitle: "आजोबा",
                value: "",
                type: "input",
                dataType: "text",
                display: false, 
                placeholder: "एकापेक्षा अधिक आजोबा नाव असतील तर वरती पर्याय आहे.",
                priority: 14,
                mandatory: false
            },
            {
                label: "relatives",
                labelTitle: "नातेवाईक",
                value: "",
                type: "input",
                dataType: "text",
                display: true, 
                placeholder: "नातेवाईकाचे केवळ आडनाव उदा. भोसले, जाधव, पवार...",
                priority: 15,
                mandatory: false
            },
            {
                label: "expections",
                labelTitle: "अपेक्षा",
                value: "",
                type: "textarea",
                dataType: "text",
                display: true, 
                placeholder: "कृपया येथे आपल्या अपेक्षा भरा उदा. मुलगा सुशिक्षित, निर्वेसनी आणि गुणी असावा, त्याला जॉब सिक्युरिटी असावी. ",
                priority: 15,
                mandatory: false
            },
        ],
        image: null
    },
    dropdownOptions: {
        rashi: ["",
            "मेष",
            "वृषभ",
            "मिथुन",
            "कर्क",
            "सिंह",
            "कन्या",
            "तूळ",
            "वृश्चिक",
            "धनु",
            "मकर",
            "कुंभ",
            "मीन"],
        gan: ["",
            "मनुष्य",
            "राक्षस",
            "देव"],
        nadi: ["",
            "आद्य",
            "मध्य",
            "अंत्य"],
        height: [
            "",
            "4 फूट 1 इंच",
            "4 फूट 2 इंच",
            "4 फूट 3 इंच",
            "4 फूट 4 इंच",
            "4 फूट 5 इंच",
            "4 फूट 6 इंच",

            "4 फूट 7 इंच",
            "4 फूट 8 इंच",
            "4 फूट 9 इंच",
            "4 फूट 10 in",
            "4 फूट 11 इंच",

            "5 फूट",
            "5 फूट 1 इंच",
            "5 फूट 2 इंच",
            "5 फूट 3 इंच",
            "5 फूट 4 इंच",
            "5 फूट 5 इंच",

            "5 फूट 6 इंच",
            "5 फूट 7 इंच",
            "5 फूट 8 इंच",
            "5 फूट 9 इंच",
            "5 फूट 10 इंच",
            "5 फूट 11 इंच",

            "6 फूट",
            "6 फूट 1 इंच",
            "6 फूट 2 इंच",
            "6 फूट 3 इंच",
            "6 फूट 4 इंच",
            "6 फूट 5 इंच",

            "6 फूट 6 इंच",
            "6 फूट 7 इंच"
        ],
        color: ["",
            "गोरा",
            "निमगोरा",
            "गव्हाळ",
            "सावळा",
            "काळा सावळा"],
        bloodgroup: ["",
            "O+",
            "O-",
            "A+",
            "A-",
            "B+",
            "B-",
            "AB+",
            "AB-"],
    }
}

export default config;
